(() => {
  'use strict';
  const init = (scope) => scope.querySelectorAll('[data-gift-chooser]:not([data-gift-ready])').forEach((root) => {
    const modes = Array.from(root.querySelectorAll('[data-gift-mode]'));
    const panels = Array.from(root.querySelectorAll('[data-gift-panel]'));
    if (modes.length !== panels.length || panels.length < 2) return;
    const show = (mode) => {
      modes.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.giftMode === mode)));
      panels.forEach((panel) => { panel.hidden = panel.dataset.giftPanel !== mode; });
    };
    panels.forEach((panel) => {
      const select = panel.querySelector('[data-gift-select]');
      if (!select) return;
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        panel.querySelector('[data-gift-price]').textContent = option.dataset.price;
        const value = panel.querySelector('[data-gift-value]');
        if (value) value.textContent = option.dataset.value;
      };
      select.addEventListener('change', update);
      update();
    });
    modes.forEach((button, index) => {
      button.addEventListener('click', () => show(button.dataset.giftMode));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? modes.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + modes.length) % modes.length;
        modes[next].focus();
        show(modes[next].dataset.giftMode);
      });
    });
    root.querySelector('.j-gift-chooser__modes').hidden = false;
    root.dataset.giftReady = 'true';
    const hashMode = location.hash === '#gutschein-papier' ? 'paper' : 'digital';
    show(hashMode);
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#gutschein-digital"],a[href="#gutschein-papier"]');
      if (link) show(link.hash === '#gutschein-papier' ? 'paper' : 'digital');
    });
  });
  const run = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
